import type { Map } from "maplibre-gl";

export function deduplicateFeatures(features: any[]): any[] {
  const uniqueIds = new Set<string>();
  return features.filter((feat) => {
    const id = feat.properties?.id;
    if (!id || id === 'user-location') return false;
    
    if (uniqueIds.has(id)) return false;
    uniqueIds.add(id);
    return true;
  });
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  timeout: number
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), timeout);
  };
}

export function getBounds(map: Map) {
  const bounds = map.getBounds();
  return {
    north: bounds.getNorth(),
    south: bounds.getSouth(),
    east: bounds.getEast(),
    west: bounds.getWest(),
  };
}
